import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getMobilePhoneCountryId = createSelector(membersState, (members) => members.update?.data?.MobilePhoneCountryId || members.data?.MobilePhoneCountryId || null);
